import { Color } from "../enums/Color"

export const errorHeader = {
    mobile: {
        row: {
            display: "flex",
            flexDirection: "row" as "row",
            position: "relative",
            zIndex: "3"
        },
        header: {
            background: Color.DeepBlack,
            marginTop: "0%",
            marginLeft: "0%",
            width: "100%",
            height: "12.14vh",
            position: "relative"
        },
        desktopImageLeft: {
            display: "none"
        },
        longBuildingSvg: {
            display: "none"
        },
        startCurve: {
            display: "none"
        },
        endCurve: {
            display: "none"
        },
        title: {
            paddingTop: "2%",
            paddingLeft: "4%",
            cursor: "pointer",
            opacity: "1",
            WebkitTapHighlightColor: "transparent",
            margin: "0",
            width: "39.37vw",
            height: "9.18vw"
        },
        label: {
            textDecoration: "none",
            fontSize: "5vw",
            fontWeight: "bold" as "bold",
            letterSpacing: "0px",
            color: Color.LightAsh,
            opacity: "1",
            cursor: "pointer",
            hover: {
                borderBottom: "0.48vw solid " + Color.DarkAsh
            }
        },
        logoutDropdownLabel: {
            color: Color.Red
        },
        logoutIcon: {
            float: "right"
        },
        logoutDropdownItem: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            hover: {
                fill: Color.White,
                backgroundColor: Color.Blue,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                color: Color.White
            },
            leave: {
                fill: Color.Red,
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        dropdownLabel: {
            position: "relative" as "relative",
            textDecoration: "none",
            fontSize: "4.4vw",
            fontWeight: "medium",
            letterSpacing: "0px",
            color: Color.MiddleBlack,
            cursor: "pointer",
            opacity: "1"
        },
        storeIcon: {
            width: "4.2vw",
            height: "4.2vw",
            paddingTop: "1vw",
            marginLeft: "0"
        },
        storeLabel: {
            fontSize: "4.34vw"
        },
        dropdownItem: {
            hover: {
                backgroundColor: Color.Blue,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                color: Color.White
            },
            leave: {
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        desktopMenu: {
            explore: {
                hover: {
                    width: "11.2vw"
                }
            },
            store: {
                hover: {
                    width: "8.8vw"
                }
            },
            storeButton: {
                hover: {
                    width: "8.8vw"
                }
            }
        },
        loginWrapper: {
            display: "contents"
        },
        recruitersButton: {
            color: Color.White,
            fontWeight: "bold" as "bold",
            backgroundColor: Color.DeepBlack,
            border: "0.16vw solid " + Color.Green,
            WebkitTapHighlightColor: "transparent",
            position: "relative" as "relative",
            marginRight: "1.04vw",
            marginTop: "2.08vw",
            transform: "none",
            width: "15vw",
            fontSize: "1.04vw",
            borderRadius: "0.6vw",
            height: "3.64vw",
            display: "none"
        },
        jobSeekersButton: {
            color: Color.White,
            fontWeight: "bold" as "bold",
            backgroundColor: Color.Blue,
            border: "none",
            cursor: "pointer",
            WebkitTapHighlightColor: "transparent",
            position: "relative" as "relative",
            marginRight: "2.60vw",
            marginTop: "2.08vw",
            transform: "none",
            width: "15vw",
            fontSize: "1.04vw",
            borderRadius: "0.6vw",
            height: "3.64vw",
            display: "none"
        },
        mobileMenuButton: {
            backgroundColor: "transparent",
            border: "none",
            marginLeft: "auto",
            marginRight: "4%",
            paddingRight: "0%",
            paddingTop: "2%"
        },
        profileWrapper: {
            display: "none"
        }
    },
    desktop: {  
        header: {
            height: "17.47vh"
        },    
        recruitersButton: {
            display: "inline"
        },
        jobSeekersButton: {
            display: "inline"
        },  
        title: {
            paddingTop: "4.9vh",
            paddingLeft: "1.5vw",
            width: "15.52vw",
            height: "3.65vw"
        },
        label: {
            fontSize: "1vw"
        },
        logoutIcon: {
            width: "0.67vw",
            height: "0.572vw"
        },
        logoutDropdownItem: {
            hover: {
                borderRadius: "0.4vw",
                padding: "0.36vw"
            },
            leave: {
                padding: "0.36vw"
            }
        },
        dropdownLabel: {
            fontSize: "1vw"
        },
        dropdownItem: {
            hover: {
                borderRadius: "0.4vw",
                padding: "0.36vw"
            },
            leave: {
                padding: "0.36vw"
            }
        },
        storeContainer: {
            display: "flex", 
            flexDirection: "row",
            justifyContent: "center", 
            alignItems: "center"
        },
        storeIcon: {
            width: "1.19vw",
            height: "1.19vw",
            paddingTop: "0"
        },
        storeLabel: {
           marginLeft: "0.52vw",
           fontSize: "1.04vw",
           marginRight: "0.1vw"
        },
        desktopMenu: {
            explore: {
                hover: {
                    width: "11.2vw"
                }
            },
            storeButton: {
                button: {
                    height: "3.64vw",
                    width: "11.09vw",
                    backgroundColor: Color.Green,
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center",
                    marginTop: "-1vw",
                    borderRadius: "0.52vw"
                },
                hover: {
                    marginTop: "1vw",
                    width: "10vw"
                }
            }
        },        
        mobileMenuButton: {
            display: "none"
        },
        profileWrapper: {
            display: "flex",
            marginTop: "3vh",
            marginRight: "1.5vw"
        }
    }
}
